var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElevator = function SvgElevator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.489 23.531V3.396c0-.26.21-.47.468-.47h16.038c.26 0 .47.21.47.47V23.53c0 .26-.21.469-.47.469H1.957a.47.47 0 0 1-.468-.469"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17 2.927V24h.981a.483.483 0 0 0 .483-.483V3.41a.483.483 0 0 0-.483-.483z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    d: "M17 24H2.953V4.859c0-.259.21-.469.469-.469h13.11c.26 0 .47.21.47.469z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m22.484 10.634-1.123-1.87a.193.193 0 0 0-.33 0l-1.123 1.87a.193.193 0 0 0 .165.293h2.245c.15 0 .243-.164.166-.293M22.484 13.366l-1.123 1.87a.193.193 0 0 1-.33 0l-1.123-1.87a.193.193 0 0 1 .165-.293h2.245c.15 0 .243.164.166.293M9.976 5.735c-.2 0-.362.162-.362.363V24h.724V6.098c0-.2-.162-.363-.362-.363"
  })));
};
export default SvgElevator;